import { app } from '../../../../app';

app.factory('HardTokenLoginModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function () {

        return $uibModal.open({
            templateUrl: require('./hard-token-login.modal.html'),
            controller: controller,
            controllerAs: 'vm'
        }).result;

        /** @ngInject */
        function controller($uibModalInstance) {
            this.cancel = () => $uibModalInstance.dismiss();
            this.ok = () => $uibModalInstance.close();
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/hard-token-login.modal.js